import React from "react";

function Icon({ className = null, seasonColor, id }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="280"
      viewBox="0 0 200 280"
      preserveAspectRatio="none"
      className={className}
      id={`${id}-svg-1`}
    >
      <g data-name="Groupe 11594" transform="rotate(180 -3771.5 -5449.5)">
        <path
          fill="#afc620"
          d="M0 45.123V0h200v45a219.392 219.392 0 00-98.836-24.013c-9.095.281-18.1.98-26.756 2.079a252.239 252.239 0 00-25.833 4.636 230.851 230.851 0 00-24.83 7.312A218.457 218.457 0 000 45.123z"
          data-name="Soustraction 1"
          transform="translate(-7743 -11179)"
        ></path>
        <path
          fill={seasonColor}
          d="M64.029 74.033H0V0c.869.838 1.618 1.563 2.359 2.283a522.643 522.643 0 0115.035 15.195l.535.56c2.767 2.9 5.625 5.9 8.339 8.891 4.293 4.741 8.8 9.966 14.2 16.444.762.917 1.54 1.84 2.292 2.734 1.677 1.992 3.411 4.053 5.041 6.111 4.715 5.93 9.515 12.368 15.106 20.26.323.458.68.951 1.125 1.554z"
          data-name="Soustraction 2"
          transform="translate(-7743 -10973.034)"
        ></path>
        <path
          fill="#06ae5c"
          d="M64.073 74.08H0c.384-.517.96-1.292 1.521-2.08 5.529-7.787 10.2-14.052 14.687-19.716 1.572-1.987 3.254-3.978 4.881-5.9.835-.988 1.7-2.01 2.54-3.024 5.406-6.5 9.922-11.73 14.212-16.465 2.966-3.257 6.073-6.523 8.752-9.328A530.853 530.853 0 0161.784 2.216c.8-.776 1.548-1.5 2.287-2.212v74.075z"
          data-name="Soustraction 3"
          transform="translate(-7607.073 -10973.08)"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;
